const STAGES = {
  te_plannen: { label: 'In te plannen', cls: 'bg-red-500/15 text-red-600 border-red-500/40' },
  montage: { label: 'Montage', cls: 'bg-orange-500/15 text-orange-600 border-orange-500/40' },
  omvormer: { label: 'Omvormer', cls: 'bg-yellow-400/25 text-yellow-700 border-yellow-500/40' },
  keuring: { label: 'Keuring', cls: 'bg-purple-500/15 text-purple-600 border-purple-500/40' },
  afgewerkt: { label: 'Afgewerkt', cls: 'bg-green-500/15 text-green-600 border-green-500/40' },
};

const fmtD = (d) => d ? new Date(d).toLocaleDateString('nl-BE') : null;

export const ProjectPhaseBadge = ({ offerte, phaseInfo }) => {
  let stage = phaseInfo?.stage;
  if (!stage) {
    const accepted = ['accepted', 'invoiced', 'geaccepteerd'].includes(offerte?.status) || offerte?.signed_at;
    if (!accepted) return null;
    stage = 'te_plannen';
  }
  const s = STAGES[stage];
  if (!s) return null;
  const dateForStage = stage === 'montage' ? fmtD(phaseInfo?.montage_date)
    : stage === 'omvormer' ? fmtD(phaseInfo?.omvormer_date)
    : stage === 'keuring' ? fmtD(phaseInfo?.keuring_date) : null;
  const tooltip = [
    phaseInfo?.montage_date ? `Montage: ${fmtD(phaseInfo.montage_date)}` : null,
    phaseInfo?.omvormer_date ? `Omvormer: ${fmtD(phaseInfo.omvormer_date)}` : null,
    phaseInfo?.keuring_date ? `Keuring: ${fmtD(phaseInfo.keuring_date)}` : null,
  ].filter(Boolean).join(' · ') || s.label;
  return (
    <span
      title={tooltip}
      data-testid={`phase-badge-${offerte?.id}`}
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium whitespace-nowrap ${s.cls}`}
    >
      {s.label}{dateForStage ? ` · ${dateForStage}` : ''}
    </span>
  );
};

export default ProjectPhaseBadge;
